import type { ReactElement } from 'react';

/**
 * LA PANTALLA DE CARGA. El símbolo de la app, con su mitad alta bajando a ponerse
 * al nivel de la otra y volviendo: se nivela mientras espera.
 *
 * Existe porque la espera se veía como un fallo. Mientras se abre IndexedDB, y
 * mientras «Actualizar» instala la versión nueva y recarga, lo que había era el
 * lienzo vacío: en el iPhone, negro (lo pidió el cliente, 2026-10-30). La misma
 * pieza está escrita a mano dentro de `#root` en `index.html`, para que se vea
 * también antes de que llegue el JavaScript; si cambias esta, cambia aquella.
 *
 * Entra con retraso: una carga rápida no llega a enseñarla, y así no parpadea.
 */
export function PantallaDeCarga(): ReactElement {
  return (
    <div className="carga app-canvas" role="status" aria-label="Cargando">
      <svg className="carga__simbolo" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="currentColor" d="M27.56,6.84 A20,20 0 0,0 17.21,45.48 Z" />
        <path
          className="carga__alta"
          fill="currentColor"
          d="M30.79,2.53 A20,20 0 0,1 20.44,41.16 Z"
        />
      </svg>
    </div>
  );
}
